import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Avatar } from 'src/components/Avatar';
import { Drawer } from 'src/components/Drawer';
import { DropdownMenu } from 'src/components/DropdownMenu';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { ListItem } from 'src/components/ListItem';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { VisitStatusDropdown } from 'src/shared/VisitStatus/VisitStatusDropdown';
import { VisitTabs } from 'src/shared/VisitTabs';

import { useClientSessionDrawer } from './useClientSessionDrawer';

import type { Appointment } from 'src/models/appointment/_types';
import type { Visit } from 'src/models/visit/_types';

interface Props {
  appointment: Appointment;
  visit: Visit;
  onClose: () => void;
}

export const ClientSessionDrawer: React.FC<Props> = ({
  appointment,
  visit,
  onClose,
}) => {
  const {
    visitPackage,
    client,
    updateVisitStatus,
    openLink,
    userManageLinks,
    user,
  } = useClientSessionDrawer(visit);

  return (
    <Drawer
      onClose={onClose}
      open={true}
      leftAdornment={
        <Stack direction="row" spacing={1}>
          <IconButton onClick={onClose}>
            <Icon
              size="small"
              icon={icon({ name: 'arrow-left', style: 'regular' })}
            />
          </IconButton>
        </Stack>
      }
      rightAdornment={
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <VisitStatusDropdown
            visit={visit}
            appointment={appointment}
            afterUpdateStatus={updateVisitStatus}
          />

          <DropdownMenu
            trigger={
              <IconButton>
                <Icon icon={icon({ name: 'ellipsis-v', style: 'regular' })} />
              </IconButton>
            }
          >
            {userManageLinks.map((link) => (
              <ListItem
                key={link.label}
                primary={link.label}
                onClick={() => {
                  openLink(link.url);
                }}
              />
            ))}
          </DropdownMenu>
        </Stack>
      }
    >
      <Stack
        direction="row"
        alignItems="center"
        // justifyContent="space-between"
        spacing={3}
        sx={{ px: 2, pb: 0, pt: 1 }}
      >
        <Avatar src={user?.profileImage} size={'large'} />
        <Typography align="justify" variant="h5">
          {user?.firstName + ' ' + user?.lastName}
        </Typography>
      </Stack>
      {visit && user && (
        <VisitTabs
          visit={visit}
          appointment={appointment}
          user={user}
          visitPackage={visitPackage}
          clientTags={client?.tags}
        />
      )}
    </Drawer>
  );
};
